import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCartAddButtonStyles = makeStyles({
    root: {
        color: 'black',
        backgroundColor: 'white',
        ...shorthands.borderColor('black'),
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        ':hover': {
            color: 'white',
            backgroundColor: 'black',
            ...shorthands.borderColor('black')
        }
    }
});
